<template>
  <v-card
    light
    class=" font-weight-bold text-xs-left pa-1 "
    style="min-height:80px;max-height:80px"
  >
    <div
      class="body-2"
      style="cursor:pointer;max-height:24px;"
      :title="campo.cmp_coluna"
      @click="openEdit(campo)"
    >
      {{ campo.cmp_titulo }}
    </div>
    <v-divider></v-divider>

    <v-btn
      v-if="campo.cmp_lista"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>list</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_add"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>add</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_edit"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>edit</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_filtro"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>search</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_ordem"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>sort_by_alpha</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_view"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>remove_red_eye</v-icon></v-btn
    >
    <v-btn
      v-if="campo.cmp_view"
      color="white"
      small
      fab
      style="zoom: 60%; '-moz-transform': 'scale(60%)';"
      ><v-icon>lock</v-icon></v-btn
    >

    <v-icon
      color="red"
      v-if="campo.cmp_pk == true"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >vpn_key</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'text'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >text_fields</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'password'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >more_horiz</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'select'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >arrow_drop_down_circle</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'radio'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >radio_button_checked</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'switch'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >toggle_on</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'date'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >event</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'datetime'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >event</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'foto'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >add_photo_alternate</v-icon
    >
    <v-icon
      color="red"
      v-else-if="campo.cmp_tipo == 'componente'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >extension</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="campo.cmp_tipo == 'arquivo'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >attach_file</v-icon
    >
    <v-icon
      color="red"
      v-else-if="campo.cmp_tipo == 'join'"
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >subdirectory_arrow_right</v-icon
    >
    <v-icon
      color="blue"
      v-else-if="
        campo.cmp_tipo == 'textarea' || campo.cmp_tipo == 'textareabasic'
      "
      :title="campo.cmp_tipo"
      dark
      absolute
      right
      bottom
      style="position:absolute;right:0px; bottom:0px;"
      >horizontal_split</v-icon
    >

    <v-btn
      color="red"
      dark
      absolute
      top
      right
      small
      fab
      style="zoom: 30%; '-moz-transform': 'scale(30%)';margin-right:-20px;margin-top:10px"
      @click="$emit('dropme')"
      ><v-icon>remove</v-icon></v-btn
    >
    <v-btn
      color="grey"
      dark
      absolute
      top
      right
      small
      fab
      style="zoom: 30%; '-moz-transform': 'scale(30%)';margin-right:-20px;margin-top:60px"
      @click="$emit('cloneme')"
      ><v-icon>file_copy</v-icon></v-btn
    >

    <v-dialog
      v-if="editDialog"
      width="800"
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="editDialog"
    >
      <camedit
        :campo="campo"
        :modulo="modulo"
        @close="saiuDaEdicao()"
      ></camedit>
    </v-dialog>
  </v-card>
</template>

<script>
/* eslint-disable */

const Camedit = global.reqClass.requirecmpmix("@/admin/metadmin/inc/camedit");

export default {
  props: ["campo", "modulo"],
  data() {
    return {
      editDialog: false
    };
  },
  methods: {
    add: function(el) {
      //console.log(el);
    },
    openEdit(node) {
      if (this.modulo.json.modulo.builder == true) return;

      this.editDialog = node;
    },
    saiuDaEdicao() {
      if (this.campo.cmp_titulo == "" || this.campo.cmp_coluna == "") {
        for (var x in this.modulo.json.campos)
          if (this.modulo.json.campos[x] == this.campo)
            this.modulo.json.campos.splice(x, 1);
      }
      this.editDialog = false;

      let res = global.modulosController.updateRest(
        this.modulo.json.modulo.mod_tabela
      );
    }
  },
  beforeMount() {
    if (
      this.campo.cmp_tipo == "" ||
      this.campo.cmp_tipo == null ||
      this.campo.cmp_coluna == "" ||
      this.campo.cmp_coluna == ""
    ) {
      this.editDialog = this.campo;
    }
  },

  components: {
    Camedit
  }
};
</script>

<style scoped>
.v-btn {
  margin: 2px;
}
</style>
